import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import ctaBackground from "@/assets/cta-background.png";

const CTASection = () => {
  const { t, language } = useLanguage();
  const isThai = language === "th";

  const benefits = [
    t("cta.benefit1"),
    t("cta.benefit2"),
    t("cta.benefit3")
  ];

  return (
    <section id="pricing" className="py-24 lg:py-32 px-2 bg-background relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-glow opacity-30" />

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="relative px-6 py-12 sm:p-12 lg:p-16 overflow-hidden rounded-3xl min-h-[500px] sm:min-h-0 bg-[#1a4d4d]">
            {/* Background Image */}
            <img 
              src={ctaBackground}
              alt=""
              className="absolute -inset-px h-[calc(100%+2px)] w-[calc(100%+2px)] object-cover object-top sm:object-right rounded-3xl"
            />

            <div className="relative text-left">
              <h2 className={`font-bold text-primary-foreground mb-6 ${isThai ? "text-2xl sm:text-3xl lg:text-4xl" : "text-3xl sm:text-4xl lg:text-5xl"}`}>
                {t("cta.title1")}
                <span className="block mt-2 text-accent">{t("cta.title2")}</span>
              </h2>

              <p className={`text-primary-foreground/80 max-w-2xl mb-8 ${isThai ? "text-base sm:text-lg" : "text-lg sm:text-xl"}`}>
                {t("cta.descriptionLine1")}
                <br />
                {t("cta.descriptionLine2")}
              </p>

              {/* Benefits */}
              <div className="flex flex-wrap justify-start gap-4 lg:gap-6 mb-10">
                {benefits.map((benefit) => (
                  <div key={benefit} className="flex items-center gap-2 text-primary-foreground/90">
                    <CheckCircle className="w-5 h-5 text-accent" />
                    <span className="text-sm font-medium">{benefit}</span>
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-start">
                <Button variant="hero" size="xl" className="w-full sm:w-auto" asChild>
                  <Link to="/contact-us">
                    {t("cta.contactUs")}
                    <ArrowRight className="w-5 h-5" />
                  </Link>
                </Button>
                <Button variant="hero-outline" size="xl" className="w-full sm:w-auto" asChild>
                  <Link to="/become-partner">
                    {t("cta.partnerWithUs")}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
